// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.list-group-item[data-v-d34088e0] {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.list-enter-active[data-v-d34088e0],\n.list-leave-active[data-v-d34088e0] {\n  transition: transform 1s;\n}\n.list-enter-from[data-v-d34088e0],\n.list-leave-to[data-v-d34088e0] {\n  opacity: 0;\n}", ""]);
// Exports
module.exports = exports;
